import { ButtonElement } from "appworks/graphics/elements/button-element";
import { AbstractControl } from "appworks/ui/controls/abstract-control";

export class EpicExternalRulesButtonControl extends AbstractControl {
    constructor(protected button: ButtonElement) {
        super();
        button.visible = false;
    }
}
